import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import MemberDetail from './MemberDetail';
import useDetailHandler from '../../hooks/useDetailHandler';
import { memberPropertiesType, memberType as memberTypeRef } from '../../types';
import './_styles_/MemberRow.css';
import { onActionKey } from '../../utils';
import { getAllMemberTypes, getMemberType } from '../../utils/MemberTypes';

export const getValueMapping = (t) => {
    const memberType = getAllMemberTypes().map((feMemberType) => ({
        from: feMemberType.serverType,
        to: feMemberType.translate(t),
    }));
    return {
        memberType,
        suspended: [
            {
                from: true,
                to: t('misc.yes'),
            },
            {
                from: false,
                to: t('misc.no'),
            },
        ],
        active: [
            {
                from: true,
                to: t('misc.yes'),
            },
            {
                from: false,
                to: t('misc.no'),
            },
        ],
    };
};

MemberRow.propTypes = {
    member: memberTypeRef.isRequired,
    memberProps: memberPropertiesType.isRequired,
};

function MemberRow(props) {
    const {
        member,
        memberProps,
    } = props;
    const { t } = useTranslation();
    const valueMapping = getValueMapping(t);
    const { isDetailVisible, toggleDetail } = useDetailHandler(member.id);
    return (
        <>
            <div className="rich-list-row member-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="member-header--values--name">{member.name}</div>
                {memberProps.availableProductTypes.includes('ENERGY') && (
                    <div className="member-header--values--balancing-group">{member.balancingGroup}</div>
                )}
                {memberProps.availableMemberTypes.length > 1 && (
                    <div className="member-header--values--member-type">
                        {getMemberType(member.memberType).translate(t)}
                    </div>
                )}
                <div className="member-header--values--member-id">{member.memberId}</div>
                <div className="member-header--values--suspended">{member.suspended ? valueMapping.suspended[0].to : valueMapping.suspended[1].to}</div>
                <div className="member-header--values--active">{member.active ? valueMapping.active[0].to : valueMapping.active[1].to}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && <MemberDetail id={member.id} memberProps={memberProps} />}
        </>
    );
}

export default MemberRow;
